import { render, staticRenderFns } from "./manage-gen-videos.vue?vue&type=template&id=63175d0e&scoped=true&"
import script from "./manage-gen-videos.vue?vue&type=script&lang=js&"
export * from "./manage-gen-videos.vue?vue&type=script&lang=js&"
import style0 from "./manage-gen-videos.vue?vue&type=style&index=0&id=63175d0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63175d0e",
  null
  
)

export default component.exports